function getCurrentYear() {
  return new Date();
}

function getTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function getTimestamp() {
  return Date.now();
}

function convertPythonTimestampToJsTimestamp(timestamp: number) {
  if (typeof timestamp !== 'number') {
    console.warn('Invalid timestamp: ', timestamp);
    return null;
  }
  return timestamp * 1000;
}

function convertTimestampToDate(timestamp: number) {
  if (typeof timestamp !== 'number') {
    console.warn('Invalid timestamp:', timestamp);
    return null;
  }
  return new Date(timestamp);
}

export {
  convertPythonTimestampToJsTimestamp,
  convertTimestampToDate,
  getCurrentYear,
  getTimestamp,
  getTimezone,
};
